import { render, staticRenderFns } from "./CreateOtherDeposit.vue?vue&type=template&id=8c271554"
import script from "./CreateOtherDeposit.vue?vue&type=script&lang=js"
export * from "./CreateOtherDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports